<template>
  <div data-scroll-focus="event-details">
    <v-container>
      <div>
        <slot name="label">
          <h2>
            {{
              $t(
                "events:EventPage.Schedule.OrganiserAndOfficials.Organiser.heading",
                "Organiser",
                "Schedule section on event page: subheading under Organisers and Officials tab"
              )
            }}
          </h2>
        </slot>
      </div>
      <v-row>
        <v-col cols="12" md="7">
          <v-card class="py-4 px-3">
            <v-row>
              <v-col cols="12" md="4">
                <AppOrganLogo
                  :organiser="event.organiser"
                  class="schedule-organiser-logo"
                />
              </v-col>

              <v-col md="8">
                <v-btn-icon
                  v-if="
                    $allowedMutation(event.allowedMutations, [
                      'eventCreateOrUpdate',
                      'noncompetitionEventCreateOrUpdate'
                    ])
                  "
                  position="absolute"
                  location="top right"
                  icon
                  size="small"
                  class="bg-edit-green ma-6"
                  :to="editPage"
                >
                  <v-icon size="small" color="white"> $edit </v-icon>
                </v-btn-icon>
                <h3 class="mb-5">
                  {{ event.organiser.name }}
                </h3>

                <div>{{ event.contactPersonName }}</div>
                <div>{{ event.contactEmail }}</div>
                <div>{{ event.contactPhone }}</div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" md="5" class="px-12 py-4">
          <div
            v-if="event.otherContactInfo"
            class="paragraph-no-margin"
            v-html="event.otherContactInfo"
          />
        </v-col>
      </v-row>
    </v-container>
    <EventRolesManagement v-if="!isNoncompetition" :event="event" />
  </div>
</template>
<script>
import gql from "fraql";
import AppOrganLogo from "@elements/AppOrganLogo.vue";
import EventRolesManagement from "./EventRolesManagement.vue";

export default {
  name: "EventContact",
  components: {
    EventRolesManagement,
    AppOrganLogo
  },
  inject: {
    isNoncompetition: {
      default: false
    }
  },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  computed: {
    editPage() {
      const name = this.isNoncompetition
        ? "NoncompetitionEventEditPage"
        : "EventEditPage";

      return {
        name,
        params: {
          eventId: this.event.id
        },
        state: {
          returnRoute: {
            name: this.$route.name,
            hash: "#details",
            params: {},
            state: {
              routeScrollState: {
                querySelector: "[data-scroll-focus='event-details']",
                disableHighlight: true
              }
            }
          },
          routeScrollState: {
            querySelector: "[data-scroll-focus='contacts']",
            disableHighlight: true,
            block: "start"
          }
        }
      };
    }
  },
  fragments: {
    disciplineFields: gql`
      fragment _ on Discipline {
        ${EventRolesManagement.fragments.disciplineFields}
      }
    `,
    contact: gql`
      fragment _ on Event {
        contactPersonName
        contactEmail
        contactPhone
        otherContactInfo
        organiser {
          id
          name
          ${AppOrganLogo.fragments.organiser}
        }
      }
    `
  }
};
</script>
